import React from "react";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Box, Slide } from "@mui/material";
import { PlayLog } from "../../../types/LogTypes";

interface LogTableProps {
  open: boolean;
  playLogs: PlayLog[];
}

export const LogTable: React.FC<LogTableProps> = ({ open, playLogs }) => {
  const columns: GridColDef[] = [
    { field: "index", headerName: "#", width: 70 },
    {
      field: "qtr",
      headerName: "Qtr",
      width: 100,
      renderCell: (params: GridRenderCellParams<PlayLog>) =>
        `${params.row.play.qtr}`,
    },
    {
      field: "time",
      headerName: "Time",
      width: 100,
      renderCell: (params: GridRenderCellParams<PlayLog>) =>
        `${params.row.play.time}`,
    },
    {
      field: "clubScore",
      headerName: "Club Score",
      width: 120,
      renderCell: (params: GridRenderCellParams<PlayLog>) =>
        `${params.row.play.clubScore}`,
    },
    {
      field: "oppScore",
      headerName: "Opponent Score",
      width: 120,
      renderCell: (params: GridRenderCellParams<PlayLog>) =>
        `${params.row.play.oppScore}`,
    },
    {
      field: "playCall",
      headerName: "Play",
      width: 150,
      renderCell: (params: GridRenderCellParams<PlayLog>) =>
        params.row.play.playCall,
    },
    {
      field: "returner",
      headerName: "Returner",
      width: 150,
      renderCell: (params: GridRenderCellParams<PlayLog>) =>
        params.row.play.returner.name,
    },
    {
      field: "yardage",
      headerName: "Yardage",
      width: 100,
      renderCell: (params: GridRenderCellParams<PlayLog>) =>
        params.row.play.kickoffYardage,
    },
    {
      field: "ballSpot",
      headerName: "Ball Spot",
      width: 120,
      renderCell: (params: GridRenderCellParams<PlayLog>) =>
        `${params.row.play.ballOn}`,
    },
  ];

  return (

    <Slide
      direction="up"
      in={open}
      mountOnEnter
      unmountOnExit
      style={{
        maxWidth: 1200,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          height: "calc(100% - 150px)", // Adjust based on header height
          bgcolor: "background.paper",
          boxShadow: 3,
          zIndex: 1000,
          borderTop: 1,
          borderColor: "divider",
        }}
      >
        <DataGrid
          rows={playLogs}
          columns={columns}
          getRowId={(row) => row.id || row.index}
          autoHeight
          disableRowSelectionOnClick
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "rgba(123, 45, 58, 0.9)",
              color: "white",
            },
          }}
        />
      </Box>
    </Slide>
  );
};
